import { Component, OnInit, ViewEncapsulation  } from '@angular/core';
import { Inject, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
// Modelos
import { OficinaFacturacion } from '../../models/OficinaFacturacion';
// Servicios
import { OficinaFacturacionService } from '../../services/oficina-facturacion.service';
import { AnyARecord } from 'dns';
import { TranslateService } from '@ngx-translate/core';
import { YesNoPipe } from '../../pipes/yesNo.pipe';
import { CellHyperlinkCustomComponent } from '../cell-hyperlink-custom/cell-hyperlink-custom.component';


@Component({
  selector: 'app-oficina-facturacion',
  templateUrl: './oficina-facturacion.component.html',
  styleUrls: ['./oficina-facturacion.component.scss']
})
export class OficinaFacturacionComponent implements OnInit {

  public displayedColumns: any[];
  public rowData: any[];
  public OficinaFacturacionTable: MatTableDataSource<OficinaFacturacion>;

  // Campos de filtrado
  defaultPageIndex;
  defaultPageSize;
  public defaultSortColumn;
  public defaultSortOrder;
  defaultFilterColumn;
  filterQuery: string;
  pageEvent: PageEvent;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(private oficinaFacturacionService: OficinaFacturacionService, private router: Router, public _translateService: TranslateService, private _booleanTransform: YesNoPipe)
  {
    console.log("constructor");
    this.displayedColumns = [
      {
        headerName: 'Editar', field: 'id', suppressFilter: true, suppressSorting: true,
        cellRendererFramework: CellHyperlinkCustomComponent,
        cellRendererParams: { destUrl: "/oficinaFacturacion/", hyperlinkText: "Editar" },
        pinned: 'left',
        width: 90,
        minWidth: 90
      },
      { field: 'oficinaCode', suppressFilter: true, suppressSorting: true, },
      { field: 'descripcion', suppressFilter: true, suppressSorting: true, },
      { field: 'nombreCompaniaNAV', suppressFilter: true, suppressSorting: true, },
      { headerName: this._translateService.instant('administracion.ag_status'), field: 'activo', minWidth: 15, valueFormatter: (data) => this._booleanTransform.transform(data.value) },
  ];
    this.defaultPageIndex = 0;
    this.defaultPageSize = 10;
    this.defaultSortColumn = 'ID';
    this.defaultSortOrder = 'desc';
    this.defaultFilterColumn = 'ID';
    this.filterQuery = null;
  }

  ngOnInit()
  {
    console.log("ngOnInit");
    this.loadData();
  }

  loadData(query: string = null)
  {
    console.log("loadData");
    this.pageEvent = new PageEvent();
    this.pageEvent.pageIndex = this.defaultPageIndex;
    this.pageEvent.pageSize = this.defaultPageSize;
    if (query)
      this.filterQuery = query;
    this.getData(this.pageEvent);
  }

  getData(event: PageEvent) : PageEvent
  {
    console.log("getData");
    let sortColumn;
    let sortOrder;
    let filterColumn;
    let filterQuery;

    sortColumn = (this.sort) ? this.sort.active: this.defaultSortColumn;
    sortOrder = (this.sort) ? this.sort.direction : this.defaultSortOrder;
    filterColumn = (this.filterQuery) ? this.defaultFilterColumn : null;
    filterQuery = (this.filterQuery) ? this.filterQuery: null;
    this.oficinaFacturacionService.getData(
      event.pageIndex,
      event.pageSize,
      sortColumn,
      sortOrder,
      filterColumn,
      filterQuery)
      .subscribe(result => {
        console.log("totalCount: "+result.totalCount);
        console.log(this.paginator);
        this.paginator.length = result.totalCount;
        this.paginator.pageIndex = result.pageIndex;
        this.paginator.pageSize = result.pageSize;
        console.log("data: "+result.data.toString());
        this.rowData = result.data;
       // this.OficinaFacturacionTable = new MatTableDataSource<OficinaFacturacion>(result.data);
      }, error => console.error(error));
      return event;
  }

  clickRow(event)
  {
    this.router.navigate([`/oficinaFacturacion/${event.data.id}`]);
  }

}
